// extracted by mini-css-extract-plugin
export default {"bullet":"Ge4ded3","list":"G16d34d","tick":"Gb16ac6 G5e65f6 G96fe7d G5b2a90"};